// extracted by mini-css-extract-plugin
module.exports = {"toggleColumn":"styles_toggleColumn__1jOPy","toggleContainer":"styles_toggleContainer__3oU1V","toggleLabel":"styles_toggleLabel__3DOjV","rtl":"styles_rtl__C8W5V"};